export default () => {
  return {
    id: null,
    customer_id: null,
    name: '',
    tag_line: '',
    project_description: '',
    order: null,
    has_filters: null,
    has_time_frame: null,
    published: null,
    type: '',
    type_id: null,
    maintenance_mode: false,
    preview_image: null,
    icon: ''
  }
}
